/* Charmoso v113 — integração dos formulários com Google Sheets */
(function () {
  'use strict';

  var ENDPOINT = 'https://script.google.com/macros/s/AKfycbxA9oxm5zWFkCFAwQaAqIRfF_fAJ_xZcVetptB909lM8_GT773HFWS3DIHF8gmhyaISEQ/exec';

  function normalizar(payload) {
    payload = payload || {};
    return {
      origem: String(payload.origem || '').trim(),
      nome: String(payload.nome || '').trim(),
      whatsapp: String(payload.whatsapp || '').trim(),
      tipoComercio: String(payload.tipoComercio || '').trim(),
      cnpj: String(payload.cnpj || '').trim(),
      email: String(payload.email || '').trim(),
      cidade: String(payload.cidade || '').trim(),
      capitalDisponivel: String(payload.capitalDisponivel || '').trim()
    };
  }

  function salvar(payload) {
    var body = JSON.stringify(normalizar(payload));

    /* sendBeacon é o caminho principal porque continua o envio mesmo quando
       o formulário abre o WhatsApp e a página começa a navegar. */
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(ENDPOINT, blob)) {
          return Promise.resolve(true);
        }
      }
    } catch (e) {}

    /* Fallback para navegadores sem sendBeacon. text/plain evita preflight CORS. */
    try {
      return fetch(ENDPOINT, {
        method: 'POST',
        mode: 'no-cors',
        cache: 'no-store',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: body
      }).then(function () { return true; }).catch(function () { return false; });
    } catch (e) {
      return Promise.resolve(false);
    }
  }

  window.CharmosoLeads = {
    salvar: salvar,
    endpoint: ENDPOINT
  };
})();
